<template>
    <div class="app-container" v-if="showEcharts">
        <div style="width: 100%;height: 500px;" ref="echartsRef1"></div>
        <div style="width: 100%;height: 300px;padding-top: 10px" ref="echartsRef2"></div>
        <div style="width: 100%;height: 500px;padding-top: 30px" ref="echartsRef3"></div>
    </div>
</template>
<script>
    import {getEchart1,getEchart2,getEchart3} from '@/echarts/report/inventory/instockCategory'
    import {countByCategorytime,sevenDaysEnterQuantity} from '@/api/report/inReport/instockTendency/instockTendency'

    export default {
        props: {
            isShow: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            isShow: {
                handler() {
                    this.showEcharts = this.isShow
                    if (this.isShow) {
                        window.addEventListener('resize', () => {
                            if (this.dataEchart1) {
                                this.dataEchart1.resize()
                            }
                            if (this.dataEchart2) {
                                this.dataEchart2.resize()
                            }
                            if (this.dataEchart3) {
                                this.dataEchart3.resize()
                            }
                        })
                        this.$nextTick(() => {
                            this.handleQuery()
                        })

                    } else {
                        this.echartDestroy()
                    }
                },
                deep: true,
                immediate: true,
            }
        },
        data() {
            return {
                showEcharts: false,
                dataEchart1: null,
                dataEchart2: null,
                dataEchart3: null,
                // 查询参数
                queryParams: {
                }
            };
        },

        beforeDestroy() {
            this.echartDestroy()
        },

        methods: {
            /** 搜索按钮操作 */
            async handleQuery() {
                let result1 = await countByCategorytime(this.queryParams)
                let result2 = await sevenDaysEnterQuantity(this.queryParams)

                let res = result1.data.instock.map(item => {
                    let top = {}
                    top.value = item.count
                    top.name = item.category
                    return top
                })
                let strList = result1.data.instock.map(item => item.category)
                let numList = result1.data.instock.map(item => item.count)
                this.dataEchart1 = this.$echarts.init(this.$refs.echartsRef1)
                this.dataEchart1.setOption(getEchart1(res))
                this.dataEchart2 = this.$echarts.init(this.$refs.echartsRef2)
                this.dataEchart2.setOption(getEchart2(strList, numList))

                let time = Array.from(new Set(result2.data.directEnter.map(item => item.date)))
                let directEnter = result2.data.directEnter.map(item => item.categoryCount)
                let productQuality = result2.data.productQuality.map(
                    item => item.categoryCount
                )
                let productReturn = result2.data.productReturn.map(item => item.categoryCount)
                let productScrap = result2.data.productScrap.map(item => item.categoryCount)
                let purchase = result2.data.purchase.map(item => item.categoryCount)
                let purchaseQuality = result2.data.purchaseQuality.map(
                    item => item.categoryCount
                )
                let saleReturn = result2.data.saleReturn.map(item => item.categoryCount)
                this.dataEchart3 = this.$echarts.init(this.$refs.echartsRef3)
                this.dataEchart3.setOption(getEchart3(time,directEnter,productQuality,productReturn,productScrap,purchase,purchaseQuality,saleReturn))
            },

            echartDestroy() {
                window.removeEventListener('resize', this.dataEchart1)
                if (this.dataEchart1) {
                    this.dataEchart1.clear();
                    this.dataEchart1.dispose();
                    this.dataEchart1 = null;
                }
                window.removeEventListener('resize', this.dataEchart2)
                if (this.dataEchart2) {
                    this.dataEchart2.clear();
                    this.dataEchart2.dispose();
                    this.dataEchart2 = null;
                }
                window.removeEventListener('resize', this.dataEchart3)
                if (this.dataEchart3) {
                    this.dataEchart3.clear();
                    this.dataEchart3.dispose();
                    this.dataEchart3 = null;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
